/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
import Copy from 'material/copy/copy';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
import Callouts from 'material/embeds/callouts/callouts';
import Callout from 'material/embeds/callouts/callout/callout_container';
import LearnMore from 'material/embeds/callouts/learnmore/learnmore';
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/revenue/revenue_styles';



/* ========== ~~~~~~~~~~ PAGE : REVENUE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class RevenuePage extends Component {
    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    handleToggle =(itemToToggle) => {
        this.props.toggleRevenueItem(itemToToggle);
    };
    checkToggleStatus(itemToToggle) {
        return this.props.revenue[itemToToggle] ? 'on' : 'off';
    }
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        const location = this.props.location === 'in-content' ? 'incontent' : 'rail';
        return(
            <Page name={`revenue`} klass={`${this.props.classes.revenue} ${this.isStep()}`}>
                <Content>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <Copy>
                        <BodyCopy>
                            <p>In addition to Ads, you can increase your Embed monetization with <strong>Market Research</strong> and <strong>Rewards</strong></p>
                        </BodyCopy>
                    </Copy>
                    <Callouts>
                        <Callout type={`marketResearch`} title={`Market Research`} handleToggle={this.handleToggle} on={this.checkToggleStatus('marketResearch')}>
                            <img src={`${url.image.app}/mks/graphic-embed-mr-${location}.png`} alt={``} />
                            <LearnMore>
                                <p>Enabling Market Research allows your readers to participate in surveys that are provided by our industry-leading partners. This is a great way to increase your overall Revenue and CPM! Insticator hosts the surveys in our B2C experience, and will soon be attributing revenue from completed surveys back to you. This is also a great way to ensure that users stay engaged on your site once they have answered all your Quiz and Poll questions.</p>
                            </LearnMore>
                        </Callout>
                        <Callout type={`profilingQuestions`} title={`Profiling Questions`} handleToggle={this.handleToggle} on={this.checkToggleStatus('profilingQuestions')}>
                            <img src={`${url.image.app}/mks/graphic-embed-profiling-${location}.png`} alt={``} />
                            <LearnMore>
                                <p>Enabling Profiling Questions allows your readers to answer lifestyle questions that help us customize their experience based on their personal attributes and interests. We use this data to find Market Research surveys that are relevant to them, which increases their survey completion percentage, meaning more revenue for you! We also use this data to create audience segments, which allow us to drive higher CPMs via supplying these segments to our demand partners.</p>
                            </LearnMore>
                        </Callout>
                        <Callout type={`rewards`} title={`Rewards`} handleToggle={this.handleToggle} on={this.checkToggleStatus('rewards')}>
                            <img src={`${url.image.app}/mks/graphic-embed-rewards-${location}.png`} alt={``} />
                            <LearnMore>
                                <p>Enabling Insticator Rewards is a great way to incentivize your readers to answer Quiz, Poll, and Profiling Questions, as well as Market Research surveys to help drive higher revenue and CPMs for you!. Your readers will earn points by answering questions and completing surveys, which they can then redeem for Amazon gift cards or Visa pre-paid cards. Insticator manages the payment of these rewards at no cost to you.</p>
                            </LearnMore>
                        </Callout>
                    </Callouts>
                    <FlowControls handleSaveEmbed={this.props.handleSaveEmbed} />
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(RevenuePage);
